import { memo } from 'react';

const ICON_CONFIG = {
    md:    { color: '#4D81E8', fold: '#9CC3F4', type: 'lines-short' },
    pdf:   { color: '#EA5355', fold: '#F78E8F', type: 'pdf' },
    docx:  { color: '#4581F4', fold: '#6E9CF4', type: 'doc-w' },
    doc:   { color: '#4581F4', fold: '#6E9CF4', type: 'doc-w' },
    xlsx:  { color: '#3AA654', fold: '#84C293', type: 'xls-x' },
    xls:   { color: '#3AA654', fold: '#84C293', type: 'xls-x' },
    pptx:  { color: '#E8793A', fold: '#F4B88A', type: 'ppt-p' },
    ppt:   { color: '#E8793A', fold: '#F4B88A', type: 'ppt-p' },
    csv:   { color: '#3AA654', fold: '#84C293', type: 'xls-x' },
    txt:   { color: '#7B8794', fold: '#B0BAC5', type: 'lines' },
    json:  { color: '#F8A100', fold: '#FFCE76', type: 'json' },
    image: { color: '#9C5EC7', fold: '#C9A0E0', type: 'image' },
    code:  { color: '#4999E9', fold: '#7CBDFF', type: 'code' },
    zip:   { color: '#E8A33D', fold: '#F4CA82', type: 'zip' },
    file:  { color: '#9E9E9E', fold: '#BDBDBD', type: 'lines' },
};

const SYMBOL_MAP = {
    'lines-short': (
        <>
            <path opacity="0.9" d="M10.169 18.236H21.835" stroke="white" strokeWidth="1.75" strokeLinecap="square" />
            <path opacity="0.9" d="M10.169 14.347H12.113" stroke="white" strokeWidth="1.75" strokeLinecap="square" />
            <path opacity="0.9" d="M15.029 14.347H16.974" stroke="white" strokeWidth="1.75" strokeLinecap="square" />
            <path opacity="0.9" d="M10.169 21.833H21.835" stroke="white" strokeWidth="1.75" strokeLinecap="square" />
        </>
    ),
    lines: (
        <>
            <path opacity="0.9" d="M10.169 18.236H21.835" stroke="white" strokeWidth="1.75" strokeLinecap="square" />
            <path opacity="0.9" d="M10.169 14.347H21.835" stroke="white" strokeWidth="1.75" strokeLinecap="square" />
            <path opacity="0.9" d="M10.169 21.833H17.5" stroke="white" strokeWidth="1.75" strokeLinecap="square" />
        </>
    ),
    pdf: (
        <path opacity="0.9" fillRule="evenodd" clipRule="evenodd" d="M14.256 11.641h2.369c0 2.95 2.54 6.113 5.706 7.169l-.541 2.297c-3.716-.53-7.556 1.055-11.023 3.368l-1.398-1.911a18.4 18.4 0 003.436-4.817c.912-2.033 1.451-4.237 1.451-6.106zm-.043 7.419c.523-1.17.987-2.382 1.379-3.61a16.8 16.8 0 003.342 3.851c-1.924.345-3.807.911-5.632 1.632.323-.615.627-1.24.911-1.873z" fill="white" />
    ),
    'doc-w': (
        <path opacity="0.9" d="M9.864 13.46h2.14l1.342 6.907h.086l1.427-6.008h2.369l1.341 6.008h.086l1.37-6.907h2.112L19.996 22.793h-2.554l-1.442-5.923h-.085l-1.47 5.923h-2.554L9.864 13.46z" fill="white" stroke="white" strokeWidth="0.117" />
    ),
    'xls-x': (
        <path opacity="0.9" d="M11.578 13.667h2.13L16 16.961l2.425-3.294h2.038L17.019 18.165 20.667 23h-2.17L16 19.435l-2.629 3.565h-2.038l3.648-4.835-3.403-4.498z" fill="white" stroke="white" strokeWidth="0.35" />
    ),
    'ppt-p': (
        <>
            <path opacity="0.9" d="M12.5 13h4.5c1.933 0 3.5 1.567 3.5 3.5S18.933 20 17 20h-2v3h-2.5V13z" fill="white" fillOpacity="0.9" />
            <path d="M14.5 15v3h2.5a1.5 1.5 0 000-3h-2.5z" fill="#E8793A" />
        </>
    ),
    json: (
        <path d="M16.095 14.952v-2.159H14v-2.158h2.095V8.476H14V6.317h2.095V4.159H14V2h2.095v2.159h2.095v2.158h-2.095v2.159h2.095v2.158h-2.095v2.159h2.095V21.048H14v-6.096h2.095zm1.333 2.286h-2.666v3.047h2.666v-3.047z" fill="white" />
    ),
    image: (
        <>
            <circle cx="13" cy="14" r="2.5" fill="white" fillOpacity="0.9" />
            <path d="M9 23l4.5-6 3 3.75 2-1.5L23 23H9z" fill="white" fillOpacity="0.9" />
        </>
    ),
    code: (
        <g opacity="0.9">
            <path d="M12.215 23.008c-1.38-1.402-2.8-2.802-4.211-4.168 1.323-1.303 2.7-2.657 4.083-4.029.364.363.73.727 1.097 1.092-1.01 1.006-2.014 2.004-2.994 2.98 1.028 1.01 2.048 2.028 3.06 3.054-.346.356-.691.713-1.035 1.071z" fill="white" stroke="white" strokeWidth="0.233" />
            <path d="M20.11 22.992c-.342-.356-.686-.711-1.03-1.066 1.015-1.026 2.039-2.044 3.07-3.053-0.977-.972-1.981-1.967-2.99-2.97.366-.365.732-.729 1.096-1.09 1.384 1.37 2.76 2.72 4.08 4.014-1.414 1.361-2.84 2.761-4.226 4.165z" fill="white" stroke="white" strokeWidth="0.233" />
            <path d="M15.883 24.175h-1.456l2.11-10.387h1.517l-2.171 10.387z" fill="white" stroke="white" strokeWidth="0.233" />
        </g>
    ),
    zip: (
        <g opacity="0.9">
            <rect x="14" y="11" width="4" height="2.5" rx="0.5" fill="white" />
            <rect x="14" y="14.5" width="4" height="2.5" rx="0.5" fill="white" />
            <rect x="14" y="18" width="4" height="2.5" rx="0.5" fill="white" />
            <rect x="14" y="21.5" width="4" height="3" rx="0.5" stroke="white" strokeWidth="1" fill="none" />
        </g>
    ),
};

const FileTypeIcon = memo(function FileTypeIcon({ iconType, size = 32 }) {
    const config = ICON_CONFIG[iconType] || ICON_CONFIG.file;
    const symbol = SYMBOL_MAP[config.type] || SYMBOL_MAP.lines;

    return (
        <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.556 26.889C3.556 28.607 4.949 30 6.667 30H25.333c1.719 0 3.111-1.393 3.111-3.111V9.778L20.667 2H6.667C4.949 2 3.556 3.393 3.556 5.111V26.889z" fill={config.color} />
            <path opacity="0.8" d="M20.667 6.667c0 1.718 1.393 3.11 3.111 3.11h4.667L20.667 2v4.667z" fill={config.fold} />
            {symbol}
        </svg>
    );
});

export default FileTypeIcon;
